import { setNotifiedProducts } from 'core/store/layout';
import { notifiedProductsLayoutSelector } from 'core/store/layout/selectors';
import { useAppDispatch, useAppSelector } from 'core/store/store.utils';
import { purchaseIncrementAppliedHandler } from 'shared/utils/purchase-increment.utils';

export const useNotifyPurchaseIncrement = () => {
  const dispatch = useAppDispatch();

  const notifiedProducts = useAppSelector(notifiedProductsLayoutSelector);
  const onNotify = (sku: string) => dispatch(setNotifiedProducts(sku));

  return { notifiedProducts, onNotify, purchaseIncrementAppliedHandler };
};
